import useCustomerlyInit from './hooks/useCustomerlyInit'

const CustomerlyImpl = (): null => {
  useCustomerlyInit()

  return null
}

export default CustomerlyImpl
